import { isEthereumLikeToken } from '@exodus/ethereum-lib';
export class ExchangeGetAllowance {
    #exchangeAssets;
    #addressProvider;
    #walletAccounts;
    constructor(params) {
        this.#addressProvider = params.addressProvider;
        this.#exchangeAssets = params.exchangeAssets;
        this.#walletAccounts = params.walletAccounts;
    }
    getAllowance = async ({ assetId, approvalAddress, walletAccount, }) => {
        const asset = this.#exchangeAssets.getAsset({ assetId });
        if (!isEthereumLikeToken(asset)) {
            return asset.currency.ZERO;
        }
        const fromAddress = await this.#addressProvider.getReceiveAddress({
            assetName: asset.name,
            walletAccount: this.#walletAccounts.get(walletAccount),
            useCache: true,
        });
        const data = asset.contract.allowance.build(fromAddress.toString(), approvalAddress);
        const allowance = await asset.baseAsset.server
            .ethCall({
            data: '0x' + data.toString('hex'),
            to: asset.contract.address,
        })
            .catch(() => 0);
        return asset.currency.baseUnit(allowance);
    };
}
const exchangeGetAllowanceModuleFactory = (args) => new ExchangeGetAllowance({ ...args });
const exchangeGetAllowanceDefinition = {
    id: 'exchangeGetAllowance',
    type: 'module',
    factory: exchangeGetAllowanceModuleFactory,
    dependencies: ['addressProvider', 'exchangeAssets', 'walletAccounts'],
};
export default exchangeGetAllowanceDefinition;
